export const FIELD_TYPE_TEXT: string = 'text';
export const FIELD_TYPE_TEXT_MULTILINE: string = 'text-multiline';
export const FIELD_TYPE_NUMBER: string = 'number';
export const FIELD_TYPE_NUMBER_DOUBLE: string = 'number-double';
export const FIELD_TYPE_NUMBER_PERCENT: string = 'number-percent';
export const FIELD_TYPE_NUMBER_CURRENCY: string = 'number-currency';
export const FIELD_TYPE_DATE: string = 'date';
export const FIELD_TYPE_DROPDOWN: string = 'dropdown';
export const FIELD_TYPE_BOOLEAN: string = 'boolean';
